import { useRef } from "react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

// "2026-10-25" -> "Sat, 25 Oct 2026" (or "25 Oct 2026" when compact)
const formatDate = (value, compact) => {
    const [y, m, d] = String(value).split("-").map(Number);
    if (!y || !m || !d) return "";
    const date = new Date(y, m - 1, d);
    const text = `${d} ${MONTHS[m - 1]} ${y}`;
    return compact ? text : `${DAYS[date.getDay()]}, ${text}`;
};

// Mobile date field: shows a readable date (or a label when empty) and opens the
// phone's own date picker on tap. The native input sits invisibly over the field.
export default function MluxDateField({ value, onChange, min, max, placeholder = "Select date", disabled = false, compact = false }) {
    const inputRef = useRef(null);
    const openPicker = () => {
        if (disabled) return;
        try { inputRef.current?.showPicker?.(); } catch (e) { /* the overlaid input still opens on tap */ }
    };
    return (
        <div className={`mlux-field mlux-datefield${disabled ? " is-disabled" : ""}`} onClick={openPicker}>
            <i className="far fa-calendar"></i>
            <div className={`mlux-datefield-text${value ? "" : " is-empty"}`}>{value ? formatDate(value, compact) : placeholder}</div>
            <i className="far fa-chevron-down mlux-datefield-chev"></i>
            <input ref={inputRef} type="date" value={value || ""} min={min} max={max} disabled={disabled}
                aria-label={placeholder} onChange={(e) => onChange && onChange(e.target.value)} />
        </div>
    );
}
